<template>
  <div class="fullheight">
    <eco-table
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      :selection="true"
      quick-search-props="name,code"
      :show-export="false"
      :show-custom-column="false"
      ref="ecoTable"
    >
      <template v-slot:toolbar>
          <el-button size="small" @click="showDialog()" type="primary">添加</el-button>
          <fe-delete-button url="${uc}/uc/tenantType/v1/remove" :htTable="$refs.ecoTable" class="marginRight16">删除</fe-delete-button>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column prop="name" label="类型名称" :sortable="true" :show-overflow-tooltip="true">
          <template v-slot="{row}">
            <el-link type="primary" @click="showDialog(row.id)" title="查看详情">{{row.name}}</el-link>
          </template>
        </eco-table-column>
        <eco-table-column prop="code" label="类型编码" :sortable="true" :show-overflow-tooltip="true">
        </eco-table-column>
        <!--<eco-table-column
          prop="status"
          label="状态"
          width="110"
          :filters="[{text:'禁用', value:'disabled'},{text:'启用', value:'enable'}]">
          <template v-slot="{row}">
            <el-tag type="warning" v-if="row.status=='disabled'">禁用</el-tag>
            <el-tag type="success" v-if="row.status=='enable'">启用</el-tag>
          </template>
        </eco-table-column>-->
        <eco-table-column
          prop="isDefault"
          label="是否默认"
          width="110"
          :filters="[{text:'否', value:'0'},{text:'是', value:'1'}]"
        >
          <template v-slot="{row}">
            <el-tag type="warning" v-if="row.isDefault=='0'">否</el-tag>
            <el-tag type="success" v-if="row.isDefault=='1'">是</el-tag>
          </template>
        </eco-table-column>
        <eco-table-column prop="createTime" label="创建时间" :sortable="true" :show-overflow-tooltip="true">
          <template v-slot="{row}">
            <span>{{row.createTime}}</span>
          </template>
        </eco-table-column>
        <eco-table-column prop="updateTime" label="最后更新时间" :sortable="true" :show-overflow-tooltip="true">
          <template v-slot="{row}">
            <span >{{row.updateTime}}</span>
          </template>
        </eco-table-column>
        <eco-table-column width="180" label="操作">
          <template v-slot="{row}">
            <el-dropdown
              size="mini"
              @command="handleCommand"
            >
              <el-link type="primary" :underline="false">
                设置管理员<i class="el-icon-arrow-down el-icon--right"></i>
              </el-link>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="{row:row,command:'assignUser'}"
                >设置管理员</el-dropdown-item>
                <el-dropdown-item
                  :command="{row:row,command:'setDefault'}"
                >设置为默认</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </eco-table-column>
      </template>
    </eco-table>
    <eco-sidebar-dialog
    destroy-on-close
      width="28%"
      :title="tenantType.id?'编辑租户类型':'新增租户类型'"
      class="sp-manager__dialog"
      :visible="dialogVisible"
      append-to-body
      :before-close="beforeCloseDialog"
    >
      <el-form v-form data-vv-scope="tenantTypeForm"  v-model="tenantType" style="padding: 20px">
        <eco-form-item label="类型名称" label-width="120px">
          <eco-input v-model="tenantType.name" validate="required" autocomplete="off"/>
        </eco-form-item>
        <eco-form-item label="类型编码" label-width="120px">
          <eco-input v-model="tenantType.code"
            autocomplete="off"
            :validate="{
              required: true,
              alpha_num: true,
              isExist: '${uc}/uc/tenantType/v1/checkCode?code='
            }"
           :disabled="tenantType.id?true:false"/>
        </eco-form-item>
        <!--<eco-form-item label="状态" label-width="120px">
          <eco-select
            v-model="tenantType.status"
            :options="[{'key': 'disabled', 'value':'禁用'},{'key': 'enable', 'value':'启用'}]"
            :validate="{'required':true}"
          />
        </eco-form-item>-->
        <eco-form-item label="类型说明" label-width="120px">
          <eco-input type="textarea" v-model="tenantType.desc" placeholder="请输入类型说明" />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="beforeCloseDialog">{{$t("eip.common.cancel")}}</el-button>
        <fe-submit-button
          url="${uc}/uc/tenantType/v1/save"
          :model="tenantType"
          scope-name="tenantTypeForm"
          @after-save-data="afterSaveData"
        >{{$t("eip.common.save")}}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
    <!-- 租户用户管理 -->
    <tenant-auth-manager ref="tenantAuthManager"></tenant-auth-manager>
  </div>
</template>
<script>

const tenantAuthManager = () => import("@/views/uc/TenantAuthManager.vue");
export default {
  components: {
    tenantAuthManager,
  },
  data() {
    return {
      dialogVisible: false,
      data: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      tenantType: {code:'',name:''}
    };
  },
  mounted() {
    this.$validator = this.$root.$validator;
  },
  methods: {
    showDialog(id) {
      if (id) {
    	  this.$http.get("${uc}/uc/tenantType/v1/getJson?id="+`${id}`).then(resp => {
              this.tenantType = resp.data;
              this.dialogVisible = true;
          }, error => {
              reject(error);
          })
      } else {
        this.dialogVisible = true;
      }
    },
    beforeCloseDialog() {
      this.tenantType = {  };
      this.dialogVisible = false;
    },
    loadData(param, cb) {
    	this.$http.post("${uc}/uc/tenantType/v1/listJson", param).then(resp => {
            let response = resp.data;
            this.data = response.rows;
            this.pageResult = {
              page: response.page,
              pageSize: response.pageSize,
              total: response.total
            };
        }, error => {
            reject(error);
        }).finally(() => cb());
    },
    afterSaveData() {
      setTimeout(() => {
        this.beforeCloseDialog();
        this.$refs.ecoTable.load();
      }, 500);
    },
    handleCommand(params) {
      switch (params.command) {
        case "edit":
          this.showDialog(params.row.id);
          break;
        case "delete":
          break;
        case "assignUser":
          this.$refs.tenantAuthManager.showDialog(params.row.id,'');
          break;
        case "setDefault":
          this.setDefault(params.row.code);
          break;
        default:
          break;
      }
    },
    setDefault(code){
      let that = this;
      this.$http.post("${uc}/uc/tenantType/v1/setDefault?code="+code).then(result => {
            let resp = result.data;
            if(resp.state){
              that.$message.success(resp.message);
              that.$refs.ecoTable.load();
            }else{
              that.$message.error(resp.message);
            }
        }, error => {
            reject(error);
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.sp-manager__dialog /deep/ > .el-dialog > .el-dialog__body {
  height: calc(100% - 170px);
}
</style>
